import { httpGet } from '../api/axios_api';
import Constants from '../../constants/constants';

export async function getGameSkillPositionData() {
  const url = `${Constants.BACKEND_URL}/get-game-skill-position-data`;
  return httpGet(url, {});
}
